var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-pricing",class:_vm.cardClass},[_vm._t("category"),_c('md-card-actions',{staticClass:"text-center"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }